<template>
  <div>
    <b-container>
      <div v-if="showoverlay" style="z-index: 999; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
        <b-spinner style="width: 3rem; height: 3rem;" label="Please wait..."></b-spinner>
      </div>
      <b-overlay class="overspin" :show="showoverlay" rounded="sm" fixed>
        <b-row>
          <b-col>
            <h4 class="mt-2" style="text-align: center;">Vendor Setup</h4>
          </b-col>
        </b-row>
        <div class="onboard">
          <b-row v-if="showStripeConfig" class="mt-3">
            <b-col><h1>Onboard a Stripe account with OAuth</h1></b-col>
          </b-row>
          <b-row v-if="showStripeConfig">
            <b-col>
              <a :href="authlink">
                 <img src="https://raw.githubusercontent.com/stripe-samples/connect-standard-oauth/master/client/blue-on-dark.png" alt="Stripe Connect" />
              </a>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-alert
                :show="dismissCountDown"
                dismissible
                fade
                @dismiss-count-down="countDownChanged"
                variant="success"
              >
              Congratulations, your Stripe Account was successfully configured!
              </b-alert>
            </b-col>
          </b-row>
        </div>
        <hr class="mt-2">
        <b-row class="mt-2">
          <b-col>Vendor Name - (ID: {{ vendor.id }})</b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-input v-model="updVen.name" @change="updateVendor()"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>Stripe Account ID</b-col>
        </b-row>
        <b-row>
          <b-col><b-form-input v-model="updVen.stripe_account_id" disabled></b-form-input></b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>Company Logo URL</b-col>
        </b-row>
        <b-row>
          <b-col><b-form-input v-model="updVen.company_logo_url" @change="updateVendor()"></b-form-input></b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>Hero Image URL</b-col>
        </b-row>
        <b-row>
          <b-col><b-form-input v-model="updVen.hero_image_url" @change="updateVendor()"></b-form-input></b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>Display Item Images:
            <b-form-checkbox v-model="updVen.display_item_images" switch @input="updateVendor()">
              <span v-if="updVen.display_item_images==true">True</span>
              <span v-else>False</span>
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>Choose TimeZone:
            <b-form-select v-model="updVen.timezone" :options="timezones" value-field="name" text-field="name" @input="updateVendor()">
            </b-form-select>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col>Addresses</b-col>
        </b-row>
        <b-list-group class="ml-5">
          <b-list-group-item>
            <b-row>
              <b-col cols="6">Address</b-col>
              <b-col cols="3">Address Type</b-col>
            </b-row>
          </b-list-group-item>
          <b-list-group-item>
            <AddAddress
              v-bind:vendor_id="vendor.id"
              @emit-switch-overlay="switchOverlay"
              @emit-update-entity="addAddressToVendor"
            ></AddAddress>
          </b-list-group-item>
          <AddressList
            v-for="address in vendor.address"
            v-bind:address="address"
            v-bind:key="address.id"
            v-bind:vendor_id="vendor.id"
            @emit-switch-overlay="switchOverlay"
            @emit-fetch-entity="fetchVendorInfo"
            @remove-address-from-entity="removeAddressFromVendor">
          </AddressList>
        </b-list-group>
      </b-overlay>
    </b-container>
  </div>
</template>

<script>
import AddressList from '@/components/AddressList.vue'
import AddAddress from '@/components/AddAddress.vue'
import moment from 'moment-timezone'

export default {
  name: "Settings",
  components: {
    AddAddress,
    AddressList
  },
  data() {
    return {
      showStripeConfig: true,
      dismissSecs: 5,
      dismissCountDown: 0,
      client_id: process.env.VUE_APP_STRIPE_CLIENT_ID,
      state: process.env.VUE_APP_STATE,
      userid: this.$auth.user.sub,
      vendor: [],
      showoverlay: false,
      updVen: {
        name: '',
        company_logo_url: '',
        hero_image_url: '',
        stripe_account_id: '',
        display_item_images: true,
        timezone: ''
      },
    }
  },

  created() {
    this.fetchVendorInfo();
    if (this.$route.query.success) {
      this.showStripeSuccessAlert()
    }
  },

  computed: {
    timezones: function() {
        const zones = moment.tz.zonesForCountry('US', true);
        return zones.filter(z=>z.name.indexOf("Indiana") === -1 && z.name.indexOf("Kentucky") === -1 && z.name.indexOf("North_Dakota") === -1);
        // return moment.tz.zonesForCountry('US', true);
    },

    authlink: function() {
      // return "https://connect.stripe.com/oauth/authorize?client_id=ca_HPPitFlFNaGqKxOzvAO7IuSqet0vrrYB&state="+this.state+"|"+this.userid+"&scope=read_write&response_type=code"
      return "https://connect.stripe.com/oauth/authorize?client_id="+this.client_id+"&state="+this.state+"|"+this.userid+"&scope=read_write&response_type=code"
    },

    vend_addr: function() {
      return this.vendor.address.map(addr => addr.id);
    },

  },

  methods: {
    switchOverlay(bool) {
      this.showoverlay = bool;
    },

    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showStripeSuccessAlert() {
      this.dismissCountDown = this.dismissSecs
    },

    addAddressToVendor(address_id) {
      // address_added in component. Add new address to vend_addr and trigger update
      this.vend_addr.push(address_id);
      this.updateVendor(this.vend_addr);
    },

    removeAddressFromVendor(address_id) {
      // remove id from vend_addr, then update
      const addr_idx = this.vend_addr.indexOf(address_id);
      this.vend_addr.splice(addr_idx, 1);
      this.updateVendor(this.vend_addr);
    },

    async fetchVendorInfo() {
      this.showoverlay = true;
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("ownvendor", {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      this.vendor = await data.vendor;
      this.updVen = data.vendor;
      this.showoverlay = false;
      // LOGIC TO DISABLE THE STRIPE LINK IF VENDOR ALREADY HAS LINKED ACCOUNT
      // if (data.vendor.stripe_account_id != null) {
      //   this.showStripeConfig=false;
      // }
    },

    async updateVendor(vendor_address=this.vend_addr) {
      this.showoverlay = true;
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      // include vend_addr
      var body = {
        "name": this.updVen.name,
        "company_logo_url": this.updVen.company_logo_url,
        "hero_image_url": this.updVen.hero_image_url,
        "display_item_images": this.updVen.display_item_images,
        "timezone": this.updVen.timezone,
        "vendor_address": vendor_address
      }
      // update order with status of 'ready'
      const { data } = await this.$api.patch('ownvendor',
        body,
        config
      );
      if (data.success == true) {
        this.fetchVendorInfo();
      } else {
        this.showoverlay = false;
        this.$bvModal.msgBoxOk('There was a problem with the update, please try again later.', {
          title: 'Error during update',
          centered: true
        })
      }
    }


  },
}
</script>
<style>
  .onboard {
    width: 70%;
    margin: auto;
    text-align: center;
  }
</style>
